import React from 'react';
import { Hero } from './Hero';
import { Methodology } from './Methodology';
import { SupportCTA } from './SupportCTA';
export function Support() {
  return <div className="min-h-screen w-full bg-white" data-id="element-636">
      <Hero data-id="element-637" />
      <Methodology data-id="element-638" />
      <SupportCTA data-id="element-639" />
    </div>;
}